import React, { Component } from 'react';
import MessageList from './MessageList';
import UserInput from './UserInput';
import Header from './Header';
import UserList from './UserList';


class ChatWindow extends Component {
    constructor(props) {
      super(props);
    }

    onUserInputSubmit(message) {
      this.props.onUserInputSubmit(message);
    }

    onMessageReceived(message) {
      this.setState({ messages: [...this.state.messages, message] });
    }

    render() {
      let messageList = this.props.messageList || [];
      let classList = [
        "sc-chat-window",
        (this.props.isOpen ? "opened" : "closed")
      ];
      const { chatMenu, onSelectUser } = this.props;
      const optionList = chatMenu && [...(chatMenu.chat_option && Object.keys(chatMenu.chat_option[0] || {}) || []).map((el, index) => ({
                    name: chatMenu.chat_option[0][el],
                    id: +el
                })) || [], ...chatMenu.bidders || [], ...chatMenu.non_bidders || [],]

      return (
        <div className={classList.join(' ')}>
          <Header
            teamName={this.props.agentProfile.teamName}
            caption={this.props.agentProfile.caption}
            imageUrl={this.props.agentProfile.imageUrl}
            onClose={this.props.onClose}
          />
          <MessageList
            messages={messageList}
            imageUrl={this.props.agentProfile.imageUrl}
            userId={this.props.userId}
            loadPreviousMessages={this.props.loadPreviousMessages}
            optionList={optionList}
          />
          {chatMenu && <UserList chatMenu={chatMenu} onSelectUser={onSelectUser}/>}
          <UserInput showEmoji={this.props.showEmoji} onSubmit={this.onUserInputSubmit.bind(this)}/>
        </div>
      );
    }
}


export default ChatWindow;
